import { SVGProps } from 'react';

const Fabrique = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#9E856D" rx="32" />
    <path
      fill="#1A1919"
      fillRule="evenodd"
      d="M41.566 35.533a3.323 3.323 0 1 1 0-6.647 3.324 3.324 0 1 1 0 6.647m-.347 5.93a1.538 1.538 0 1 1-2.175-2.175 1.538 1.538 0 0 1 2.175 2.174m-9.214-6a3.325 3.325 0 1 1 0-6.65 3.325 3.325 0 0 1 0 6.65m-.037 9.673a3.324 3.324 0 1 1-.001-6.65 3.324 3.324 0 0 1 .001 6.65m-9.6-9.602a3.323 3.323 0 1 1 0-6.647 3.324 3.324 0 0 1 0 6.647m2.521 5.93a1.539 1.539 0 1 1-2.174-2.178 1.539 1.539 0 0 1 2.174 2.178m-2.176-18.506a1.538 1.538 0 1 1 2.176 2.174 1.538 1.538 0 0 1-2.176-2.174m9.255-3.672a3.324 3.324 0 1 1-.002 6.648 3.324 3.324 0 0 1 .002-6.648m7.077 3.67a1.54 1.54 0 1 1 2.175 2.179 1.54 1.54 0 0 1-2.175-2.178M32 16c-8.837 0-16 7.164-16 16 0 8.837 7.163 16 16 16 8.836 0 16-7.163 16-16 0-8.836-7.164-16-16-16"
      clipRule="evenodd"
    />
  </svg>
);

export default Fabrique;
